import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';

export const LegalNav = styled.nav`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  border-bottom: 1px solid var(--border);
  height: var(--nav-h);
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 50;
`;

export const LegalNavInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: var(--maxw);
  padding: 0 24px;
`;

export const LegalNavLogo = styled(LinkR)`
  color: var(--ink);
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const LegalLogoDot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--accent);
  display: inline-block;
  margin-top: 4px;
`;

export const LegalNavLinks = styled.div`
  display: flex;
  gap: 8px;
`;

export const LegalNavLink = styled(LinkR)`
  color: var(--text);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 8px 14px;
  border-radius: var(--radius-pill);
  transition: color 0.18s ease, background 0.18s ease;

  &:hover {
    color: var(--ink);
    background: var(--bg-subtle);
  }
`;

export const LegalMain = styled.main`
  background: var(--bg);
  min-height: calc(100vh - var(--nav-h));
`;

export const LegalContainer = styled.div`
  max-width: 760px;
  margin: 0 auto;
  padding: 72px 24px 96px 24px;
`;

export const LegalTitle = styled.h1`
  font-size: 2.6rem;
  font-weight: 800;
  margin-bottom: 8px;
  color: var(--ink);

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const LegalUpdated = styled.p`
  color: var(--muted);
  font-size: 0.95rem;
  margin-bottom: 44px;
`;

export const LegalH2 = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  margin: 40px 0 14px 0;
  color: var(--ink);
`;

export const LegalP = styled.p`
  font-size: 1.05rem;
  line-height: 1.78;
  margin-bottom: 18px;
  color: var(--text);
`;

export const LegalA = styled.a`
  color: var(--accent-strong);
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: var(--accent);
  }
`;
